<template>
  <span
    class="variables row inline items-center"
    :class="`variables__${className}`"
    contenteditable="false"
  >
    <span>{{ name }}</span>
    <q-icon
      v-if="isEditable && !disable"
      size="medium"
      name="mdi-pencil"
      @click.native.stop="openCustomText = true"
    >
      <q-tooltip isEditable :delay="200">
        {{ editableText }}
      </q-tooltip>
      <q-dialog v-model="openCustomText">
        <span slot="title">{{
          name[0].toUpperCase() + name.substring(1)
        }}</span>
        <span slot="message">
          <q-input type="textarea" v-model="editableText" />
        </span>
      </q-dialog>
    </q-icon>
    <q-icon
      v-if="!onlyReadable"
      size="medium"
      name="mdi-close"
      clickable
      :onclick="remove"
    ></q-icon>
  </span>
</template>

<script>
export default {
  methods: {
    getEditableText() {
      if (!this.customText) return '';
      const key = Object.keys(this.customText)[0];
      return this.customText[key];
    },
  },
  data() {
    return {
      openCustomText: false,
      editableText: this.getEditableText(),
    };
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    onlyReadable: {
      type: Boolean,
      default: false,
    },
    customText: {},
    disable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    className() {
      return this.name.toLowerCase().split(' ').join('-');
    },
    isEditable() {
      return this.customText !== undefined;
    },
    remove() {
      return 'this.parentNode.parentNode.removeChild(this.parentNode)';
    },
  },
  watch: {
    editableText() {
      this.$emit(
        'onEditText',
        Object.keys(this.customText)[0],
        this.editableText,
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
.variables {
  background-color: lightgrey;
  border-radius: 20px;
  padding: 5px 10px;
  margin: 5px;

  i {
    margin-left: 5px;
  }

  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
}
</style>
